import React, { useEffect, useState } from 'react';
import useUserVerification from '../user/useUserVerification';
import ErrorPage from '../../pages/ErrorPage';
import { useAuth } from '../../AuthContext';

const ProtectedRoute = ({ children, requiredChecks = { login: true, verified: false, premium: false, admin: false, support: false }, customMessages = {} }) => {
  const { role } = useAuth();
  const { verifyUser, modals, setShowLoginModal, setShowResendModal, message } = useUserVerification();
  const [verificationStatus, setVerificationStatus] = useState('loading');

  useEffect(() => {
    const status = verifyUser(requiredChecks, customMessages);
    setVerificationStatus(status);
  }, [verifyUser, requiredChecks, customMessages, role]);

  useEffect(() => {
    if (verificationStatus === 'login') {
      setShowLoginModal(true);
    } else if (verificationStatus === 'verified') {
      setShowResendModal(true);
    }
  }, [verificationStatus, setShowLoginModal, setShowResendModal]);

  if (verificationStatus === 'loading') {
    return null;
  }

  if (verificationStatus === 'admin') {
    return <ErrorPage message="You appear to be lost." />;
  }

  if (verificationStatus !== 'success') {
    return (
      <>
        <ErrorPage message={message} />
        {modals}
      </>
    );
  }

  return children;
};

export default ProtectedRoute;
